import { useState, useEffect } from 'react';
import useAxios from 'axios-hooks';

export const usePeer = () => {
  const [id, setId] = useState();
  const [report, getReport] = useState();
  const namespace = 'peer-comparisons'

  //Member Type & Proximity request
  const [
    {
      data,
      loading,
      error,
    },
    getPeerReport,
  ] = useAxios({ url: `${namespace}/${report}` }, { manual: true })

  useEffect(() => {
    report && getPeerReport()
  }, [report])

  //Get all org
  const [
    {
      data: dataOrganizations,
      loading: loadingOrganizations,
      error: errorOrganizations,
    },
    executeOrganizations,
  ] = useAxios({ url: 'peer-comparisons/organizations' }, { manual: true });

  //Get organization by Id
  const [
    {
      data: dataSingleOrg,
      loading: loadingSingleOrg,
      error: errorSingleOrg,
    },
    executeSingleOrg,
  ] = useAxios(
    { url: `peer-comparisons/organizations/${id}` },
    { manual: !id }
  );

  return {
    dataOrganizations,
    loadingOrganizations,
    errorOrganizations,
    executeOrganizations,
    dataSingleOrg,
    loadingSingleOrg,
    errorSingleOrg,
    setId,
    executeSingleOrg,
    data,
    loading,
    error,
    getReport,
  };
};
